var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"product-item"},[_c('img',{staticClass:"product-image",attrs:{"src":_vm.productImage}})]),_c('div',{staticClass:"product-info"},[_c('h4',{directives:[{name:"thematic",rawName:"v-thematic"}]},[_vm._v(_vm._s(_vm.productDisplayName))]),(_vm.displayPrice)?_c('span',{class:{
        'product-price': true,
        'product-discount-price': !!_vm.promotionDiscount
      }},[_vm._v(_vm._s(_vm.displayPrice)+_vm._s(_vm.currency.symbol))]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }